import React, { Component } from 'react';
import AddressList from '../../components/Customer/AddressList.jsx';
import AddressUpdate from '../Address/Update.jsx';
import AddressCreate from '../Address/Create.jsx';
import { Route, Switch, Redirect } from 'react-router-dom';

const sendProps = props => {
    const { classes, ...rest } = props;
    return rest;
};
export class Address extends Component {
    render() {
        const { match } = this.props;
        console.warn(match)
        return (
            <div className="tz-2-com tz-2-main">
                <div className="row">
                    <div className="col-md-12">
                        <Switch>
                            <Route
                                path={`/user/profile/initial`}
                                exact={true}
                                render={props => (
                                    <AddressList
                                        {...props}
                                        {...sendProps(this.props)}
                                    />
                                )}
                            />
                             <Route
                                path={`/user/address`}
                                exact={true}
                                render={props => (
                                    <AddressList
                                        {...props}
                                        {...sendProps(this.props)}
                                    />
                                )}
                            />
                            <Route
                                path={`/user/address/create`}
                                exact={true}
                                render={props => (
                                    <AddressCreate
                                        {...props}
                                        {...sendProps(this.props)}
                                    />
                                )}
                            />
                            <Route
                                path={`/user/address/update/:addressId`}
                                exact={true}
                                render={props => (
                                    <AddressUpdate
                                        {...props}
                                        {...sendProps(this.props)}
                                    />
                                )}
                            />
                        </Switch>
                    </div>
                </div>
            </div>
        );
    }
}
// const composedAddress = compose(withStyles(styles));
export default Address;



// WEBPACK FOOTER //
// ./src/views/User/Address.jsx